import React from 'react';
import styles from './styles.module.scss';
import icBattleRewards from 'assets/svg/ic_battle_rewards.svg';
import icSearch from 'assets/svg/ic_white_search.svg';
import TableHeader from './Components/TableHeader';
import PaginationControl_V2 from '@profile/src/Components/PaginationControl_V2';
import BreakpointContent from '@profile/src/Components/BreakpointContent';
import PageContent from '@profile/src/Components/PageContent';
import { useTypedDispatch, useTypedSelector } from '@profile/src/redux/utils';
import { AppError } from '@profile/src/redux/types';
import EmptyList from '@profile/src/Components/EmptyList';
import Spinner from '@profile/src/Components/Spinner';
import useParamsRoute from '@profile/src/hooks/useRouteParams';
import { DEFAULT_ITEM_PER_PAGE } from '@profile/src/Profile_V2/Components/Ingame/constants';
import { fetchBattleRewards } from '@profile/src/redux/actions';
import { navigateToInGamePage } from '@profile/src/utils/navigate';
import { InGameCategoryKey } from '@profile/src/Profile_V2/Components/Ingame/types';
import { normaliseSearchUrl } from '@profile/src/utils/query';
import TableContentDesktop from './Components/TableContentDesktop';
import TableContentMobile from './Components/TableContentMobile';
import icClose from 'assets/svg/ic_close.svg';

const BattleRewards = () => {
  const dispatch = useTypedDispatch();
  const {
    data,
    error,
    loading,
    invalidated,
    totalItems
  } = useTypedSelector(state => state.battleRewards);
  const {
    page = 1,
    s = ''
  } = useParamsRoute();
  const [searchValue, setSearchValue] = React.useState(s);
  const totalPages = Math.ceil(totalItems / DEFAULT_ITEM_PER_PAGE) || 1;

  const pushSearchUrl = urlSearch => {
    navigateToInGamePage({
      urlSearch,
      category: InGameCategoryKey.BattleRewards
    });
  };

  const onFetch = React.useCallback((page, search) => {
    dispatch(fetchBattleRewards(search, (page - 1) * DEFAULT_ITEM_PER_PAGE, DEFAULT_ITEM_PER_PAGE));
  }, [dispatch]);

  const onPageChange = nextPage => {
    const urlSearch = normaliseSearchUrl({
      page: nextPage,
      s
    });
    pushSearchUrl(urlSearch);
  };

  const onSearch = event => {
    event.preventDefault();
    const target = event.target;
    const urlSearch = normaliseSearchUrl({
      page,
      s: target.search.value
    });
    pushSearchUrl(urlSearch);
  };

  const onClearSearch = event => {
    event.preventDefault();
    setSearchValue('');
    const urlSearch = normaliseSearchUrl({
      page,
      s: ''
    });
    pushSearchUrl(urlSearch);
  };

  React.useEffect(() => {
    onFetch(page, s);
  }, [onFetch, page, s]);

  const renderDesktopTablet = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.table
    }, /*#__PURE__*/React.createElement(TableHeader, null), /*#__PURE__*/React.createElement(TableContentDesktop, {
      data: data
    }), /*#__PURE__*/React.createElement(PaginationControl_V2, {
      page: page,
      totalPages: totalPages,
      onPageChange: onPageChange
    }));
  };

  const renderMobile = () => {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TableContentMobile, {
      data: data
    }), /*#__PURE__*/React.createElement(PaginationControl_V2, {
      page: page,
      totalPages: totalPages,
      onPageChange: onPageChange
    }));
  };

  const renderError = () => {
    return /*#__PURE__*/React.createElement(EmptyList, {
      title: "Sorry, no record found.",
      content: "Please try again.",
      className: styles.empty
    });
  };

  const renderLoading = () => {
    return /*#__PURE__*/React.createElement(Spinner, {
      className: styles.spinner
    });
  };

  const renderContent = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.header
    }, /*#__PURE__*/React.createElement("img", {
      src: icBattleRewards,
      alt: ""
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.title
    }, /*#__PURE__*/React.createElement("span", null, "Battle Reward"))), /*#__PURE__*/React.createElement("form", {
      autoComplete: "off",
      className: styles.search,
      onSubmit: event => onSearch(event)
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      name: "search",
      placeholder: "Search",
      value: searchValue,
      onChange: event => setSearchValue(event.target.value),
      className: styles.input
    }), !!searchValue && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: styles.clearSearchBtn,
      onClick: onClearSearch
    }, /*#__PURE__*/React.createElement("img", {
      src: icClose,
      alt: "Search"
    })), /*#__PURE__*/React.createElement("button", {
      type: "submit",
      className: styles.searchButton
    }, /*#__PURE__*/React.createElement("img", {
      src: icSearch,
      alt: "Search"
    }))), /*#__PURE__*/React.createElement(BreakpointContent, {
      renderPhone: renderMobile,
      renderTablet: renderDesktopTablet,
      renderDesktop: renderDesktopTablet
    }));
  };

  return /*#__PURE__*/React.createElement(PageContent, {
    renderContent: renderContent,
    renderLoading: renderLoading,
    renderError: renderError,
    error: error !== AppError.NO_ERROR,
    loading: loading,
    invalidated: invalidated
  });
};

export default BattleRewards;